export class SectionTileErrorSectionRequired {
  private sections: string;
  constructor() {
    this.sections = '';
  }
}

class SectionTileErrorSectionRequiredComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      errorTitle: '@',
      sections: '<',
      errorMsg: '@'
    };
    this.controller = SectionTileErrorSectionRequired;
    this.templateUrl =
      'capability-ng-scheduler/src/views/course_scheduler/components/section_tile_error_section_required/section_tile_error_section_required.html';
  }
}
angular
  .module('capability-ng-scheduler')
  .component('sectionTileErrorSectionRequired', new SectionTileErrorSectionRequiredComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/components/section_tile_error_section_required/section_tile_error_section_required.ts